import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AxAuthenticationGuard } from '@atlasx/core/authentication';

const routes: Routes = [
    {
        path: 'home',
        loadChildren: () =>
            import('./home/home.module').then((m) => m.HomePageModule),
    },
    {
        path: 'gis',
        loadChildren: () =>
            import('./gis/gis.module').then((m) => m.GisPageModule),
    },
    {
        path: 'login',
        loadChildren: () =>
            import('./login/login.module').then((m) => m.LoginPageModule),
    },
    // {
    //     path: 'callback',
    //     loadChildren: () =>
    //         import('./core/callback/callback.module').then(
    //             (m) => m.CallbackPageModule
    //         ),
    // },
    {
        path: 'callback',
        loadChildren: () =>
            import('./pages/callback/callback.module').then(
                (m) => m.CallbackPageModule
            ),
    },
    {
        path: 'um',
        canActivate: [AxAuthenticationGuard],
        loadChildren: () =>
            import('./um/um.module').then((m) => m.UmPageModule),
    },
    {
        path: '',
        loadChildren: () =>
            import('./pages/layout/layout.module').then(
                (m) => m.LayoutPageModule
            ),
    },
    {
        path: 'landing',
        loadChildren: () =>
            import('./pages/landing/landing.module').then(
                (m) => m.LandingPageModule
            ),
    },
    {
        path: '**',
        redirectTo: '/landing',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
